// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__xnQzP","footer":"Form_footer__3TkeU"};